import type { AuditStatus } from "../offline/audit";

export interface EvictionRecoveryModalProps {
  status: AuditStatus;
  missing: string[];
  online: boolean;
  onReconnectDownload: () => void;
  onClose: () => void;
}

export function EvictionRecoveryModal(props: EvictionRecoveryModalProps): JSX.Element {
  const copy = props.status === "schema-mismatch"
    ? "Annotations format updated. Reconnect to refresh."
    : "This flight's offline cache has been cleared (browser storage was evicted).";
  return (
    <div role="dialog" aria-label="Offline cache issue"
      style={{ position: "fixed", inset: 0, display: "grid", placeItems: "center",
        background: "rgba(0,0,0,0.6)", zIndex: 2000 }}>
      <div style={{ background: "#1a1a1a", color: "#eee", padding: 20, minWidth: 360 }}>
        <h3>Offline cache needs attention</h3>
        <p>{copy}</p>
        {props.missing.length > 0 && (
          <p style={{ fontSize: 12, color: "#aaa" }}>
            Missing: {props.missing.join(", ")}
          </p>
        )}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button type="button" onClick={props.onClose}>Close</button>
          {props.online && (
            <button type="button" onClick={props.onReconnectDownload}>
              Reconnect and re-download
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
